import {
  BE_ESB,
  ESB_GET_DEPARTMENT,
  ESB_GET_LOCATION,
  ESB_GET_SIMPER,
  ESB_GET_SUBLOCATION,
  ESB_GET_TOKEN,
  TOKEN_ESB,
} from "@/constants";
import axios from "axios";

const get_location = BE_ESB + ESB_GET_LOCATION;
const get_sublocation = BE_ESB + ESB_GET_SUBLOCATION;
const get_token = BE_ESB + ESB_GET_TOKEN;
const get_simper = BE_ESB + ESB_GET_SIMPER;
const get_department = BE_ESB + ESB_GET_DEPARTMENT;

export const getESBLocation = debounceAsync(async (name) => {
  let esb_token = JSON.parse(localStorage.getItem("esb_token")) || {};
  if (!esb_token.token || !isTokenValid(esb_token.token)) {
    esb_token.token = await getESBExternalToken();
    localStorage.setItem("esb_token", JSON.stringify(esb_token));
  }

  let params = {
    name: name,
  };

  const result = await axios.get(get_location, {
    params: params,
    headers: {
      Authorization: `Bearer ${esb_token.token}`,
      accept: "*/*",
    },
  });

  return result.data;
}, 700);

export const getESBSubLocation = debounceAsync(async (id_location, name) => {
  let esb_token = JSON.parse(localStorage.getItem("esb_token")) || {};
  if (!esb_token.token || !isTokenValid(esb_token.token)) {
    esb_token.token = await getESBExternalToken();
    localStorage.setItem("esb_token", JSON.stringify(esb_token));
  }

  let params = {
    id_location: id_location,
    name: name,
  };

  const result = await axios.get(get_sublocation, {
    params: params,
    headers: {
      Authorization: `Bearer ${esb_token.token}`,
      accept: "*/*",
    },
  });

  return result.data;
}, 700);

export const getSimper = debounceAsync(async (keyword) => {
  let esb_token = JSON.parse(localStorage.getItem("esb_token")) || {};
  if (!esb_token.token || !isTokenValid(esb_token.token)) {
    esb_token.token = await getESBExternalToken();
    localStorage.setItem("esb_token", JSON.stringify(esb_token));
  }

  let params = {
    is_internal: true,
    page: 1,
    size: 10,
    name: keyword,
  };

  const result = await axios.get(get_simper, {
    params: params,
    headers: {
      Authorization: `Bearer ${esb_token.token}`,
      accept: "*/*",
    },
  });

  return result.data;
}, 700);

export const getDepartment = debounceAsync(async () => {
  let esb_token = JSON.parse(localStorage.getItem("esb_token")) || {};
  if (!esb_token.token || !isTokenValid(esb_token.token)) {
    esb_token.token = await getESBExternalToken();
    localStorage.setItem("esb_token", JSON.stringify(esb_token));
  }

  let params = {
    page: 1,
    size: 100,
  };

  const result = await axios.get(get_department, {
    params: params,
    headers: {
      Authorization: `Bearer ${esb_token.token}`,
      accept: "*/*",
    },
  });

  return result.data;
}, 500);

export const getSimperDynamic = debounceAsync(
  async ({ email, is_internal = true, isafe_number, name, size, page, status_karyawan = 0 }) => {
    let esb_token = JSON.parse(localStorage.getItem("esb_token")) || {};
    if (!esb_token.token || !isTokenValid(esb_token.token)) {
      esb_token.token = await getESBExternalToken();
      localStorage.setItem("esb_token", JSON.stringify(esb_token));
    }

    let params = {
      is_internal: is_internal,
      email: email,
      isafe_number: isafe_number,
      name: name,
      size: size,
      page: page,
      status_karyawan,
    };

    const result = await axios.get(get_simper, {
      params: params,
      headers: {
        Authorization: `Bearer ${esb_token.token}`,
        accept: "*/*",
      },
    });

    return result.data;
  },
  500,
);

function debounceAsync(func, wait) {
  let timeout;
  return (...args) =>
    new Promise((resolve) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => resolve(func(...args)), wait);
    });
}

function isTokenValid(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Math.floor(Date.now() / 1000);

    return payload.exp > currentTime;
  } catch (e) {
    return false;
  }
}

const getESBExternalToken = async () => {
  const result = await axios.get(get_token, {
    headers: {
      Authorization: `Bearer ${TOKEN_ESB}`,
    },
  });
  return result.data.token;
};
